import { Fragment, useState } from "react";
import Config from "../../../Config";


import g_ubrania from "../../../wyprawka/g_ubrania.png";
import g_chusteczki from "../../../wyprawka/g_chusteczki.png";
import g_chusteczki_nawilzone from "../../../wyprawka/g_chusteczki_nawilzone.png";
import g_money from "../../../wyprawka/g_money.png";
import g_pampers from "../../../wyprawka/g_pampers.png";
import g_pasta from "../../../wyprawka/g_pasta.png";
import g_szczoteczka from "../../../wyprawka/g_szczoteczka.png";
import g_milk from "../../../wyprawka/g_milk.png";

import e_smile from "../../../emotki/smile.png";
import e_neutral from "../../../emotki/neutral.png";
import e_bad from "../../../emotki/sad.png";


function Book(props)
{

    
    const [refreshView, setRefreshView] = useState(props.userData.refreshView);
    const [tab, setTab] = useState(null);


    const getData = () => {


        props.mainView.setProgress(-2);
 

        fetch( Config.url + '/rest_v1_parents,book', {
            method: 'POST', 
            body: JSON.stringify({}), 
            headers: {
                'Content-Type': 'application/json',                    
                'X-Api-Key': props.userData.apiKey,
                '_p_przedszkole_id_': props.userData.p_przedszkole_id,
                '_p_dziecko_id_': props.userData.p_dziecko_id,
                '_sec_key_': Config.genXKey() ,
            }
         })
         .then(res => res.json() )
         .then(res => { 

                    props.mainView.setProgress(-1);        
                    if(res._sys_ == undefined)
                    {
                        props.mainView.showDialog( "Error", "No correct response from server" , "ok" , null);  
                    }else
                    if(res.status != undefined && res.status == 'ERROR'  && res.result != undefined )
                    {
                        props.mainView.showDialog( "Error", JSON.stringify(res.result) , "ok" , null);  
                    }else    
                    {
                        setTab(res.result);                                                                                         
                    }
         } )
         .catch(err => {          
                    props.mainView.showDialog( "Error", "I: " + err , "ok" , null);
                    props.mainView.setProgress(-1);
         });
               



    }




    
    if(tab == null)
        {
            setTab([]);
            getData();      
            return (
                <div></div>
            );        
        }


    
    if(refreshView != props.userData.refreshView)
    {         
          setRefreshView( props.userData.refreshView);
          setTab(null);
    }    




    return <div>

            

            <ul className="parents_eat">
                   
                    {
                        tab.length == 0  &&
                        <div className="big_msg">
                            Dzienniczek nie zawiera żadnych wpisów
                        </div>
                    }

                    {
                        tab.map( (item, ix) => {

                            return <Fragment>

                                <li>

                                    <div className="site_book">

                                                <div className="calColor">                                    
                                                    {item.data_dodania}
                                                </div>

                                                <div>
                                                    <p>
                                                            {item.opis} 
                                                    </p>                                                        
                                                </div>
                                    

                                                {
                                                            item.ocena != 0 &&
                                                            <div>
                                                                <div className="book_title">Ocena ogólna z pracy na lekcji: </div>
                                                                {
                                                                    item.ocena == 1 &&
                                                                    <Fragment>
                                                                         <img src={e_smile} className="book_emo" title="Dobra"/> Dobra
                                                                    </Fragment>                                                                   
                                                                }
                                                                {
                                                                    item.ocena == 3 &&
                                                                    <Fragment>
                                                                        <img src={e_neutral} className="book_emo" title="Przeciętnie"/> Przeciętnie
                                                                    </Fragment>                                                                    
                                                                }                                                                
                                                                {
                                                                    item.ocena == 2 &&
                                                                    <Fragment>
                                                                        <img src={e_bad} className="book_emo" title="Słabo"/> Słabo
                                                                    </Fragment>                                                                    
                                                                }
                                                            </div>
                                                }

                                                {
                                                            item.sniadanie_1 != 0 &&
                                                            <div>
                                                                <div className="book_title">Pierwsze śniadanie:</div>
                                                                {
                                                                    item.sniadanie_1 == 1 &&
                                                                    <Fragment>
                                                                        <img src={e_smile} className="book_emo" title="Zjedzone w całości"/> Zjedzone w całości
                                                                    </Fragment>                                                                    
                                                                }
                                                                {
                                                                    item.sniadanie_1 == 3 &&
                                                                    <Fragment>
                                                                            <img src={e_neutral} className="book_emo" title="Częściowo zjedzone"/> Częściowo zjedzone
                                                                    </Fragment>                                                                    
                                                                }                                                                
                                                                {
                                                                    item.sniadanie_1 == 2 &&
                                                                    <Fragment>
                                                                            <img src={e_bad} className="book_emo" title="Niezjedzone wcale"/> Niezjedzone wcale
                                                                    </Fragment>                                                                    
                                                                }
                                                            </div>
                                                }


                                                {
                                                            item.sniadanie_2 != 0 &&
                                                            <div>
                                                                <div className="book_title">Śniadanie, drugie danie:</div>
                                                                {
                                                                    item.sniadanie_2 == 1 &&
                                                                    <Fragment>
                                                                            <img src={e_smile} className="book_emo" title="Zjedzone w całości"/> Zjedzone w całości
                                                                    </Fragment>                                                                    
                                                                }
                                                                {
                                                                    item.sniadanie_2 == 3 &&
                                                                    <Fragment>
                                                                            <img src={e_neutral} className="book_emo" title="Częściowo zjedzone"/> Częściowo zjedzone
                                                                    </Fragment>                                                                    
                                                                }                                                                
                                                                {
                                                                    item.sniadanie_2 == 2 &&
                                                                    <Fragment>
                                                                            <img src={e_bad} className="book_emo" title="Niezjedzone wcale"/> Niezjedzone wcale
                                                                    </Fragment>                                                                    
                                                                }
                                                            </div>
                                                }


                                                {
                                                            item.obiad_danie_1 != 0 &&
                                                            <div>
                                                                <div className="book_title">Obiad:</div>
                                                                {
                                                                    item.obiad_danie_1 == 1 &&
                                                                    <Fragment>
                                                                                <img src={e_smile} className="book_emo" title="Zjedzone w całości"/> Zjedzone w całości
                                                                    </Fragment>                                                                    
                                                                }
                                                                {
                                                                    item.obiad_danie_1 == 3 &&
                                                                    <Fragment>
                                                                            <img src={e_neutral} className="book_emo" title="Częściowo zjedzone"/> Częściowo zjedzone
                                                                    </Fragment>                                                                    
                                                                }                                                                
                                                                {
                                                                    item.obiad_danie_1 == 2 &&
                                                                    <Fragment>
                                                                            <img src={e_bad} className="book_emo" title="Niezjedzone wcale"/> Niezjedzone wcale
                                                                    </Fragment>                                                                    
                                                                }
                                                            </div>
                                                }


                                                {
                                                            item.obiad_danie_2 != 0 &&
                                                            <div>
                                                                <div className="book_title">Obiad, drugie danie:</div>
                                                                {
                                                                    item.obiad_danie_2 == 1 &&
                                                                    <Fragment>
                                                                                <img src={e_smile} className="book_emo" title="Zjedzone w całości"/> Zjedzone w całości
                                                                    </Fragment>                                                                   
                                                                }
                                                                {
                                                                    item.obiad_danie_2 == 3 &&
                                                                    <Fragment>
                                                                                <img src={e_neutral} className="book_emo" title="Częściowo zjedzone"/> Częściowo zjedzone
                                                                    </Fragment>                                                                    
                                                                }                                                                
                                                                {
                                                                    item.obiad_danie_2 == 2 &&
                                                                    <Fragment>
                                                                            <img src={e_bad} className="book_emo" title="Niezjedzone wcale"/> Niezjedzone wcale
                                                                    </Fragment>                                                                    
                                                                }
                                                            </div>
                                                }
                                                    

                                                {
                                                            item.podwieczorek != 0 &&
                                                            <div>
                                                                <div className="book_title">Podwieczorek:</div>
                                                                {
                                                                    item.podwieczorek == 1 &&
                                                                    <Fragment>
                                                                        <img src={e_smile} className="book_emo" title="Zjedzone w całości"/> Zjedzone w całości
                                                                    </Fragment>                                                                    
                                                                }
                                                                {
                                                                    item.podwieczorek == 3 &&
                                                                    <Fragment>
                                                                        <img src={e_neutral} className="book_emo" title="Częściowo zjedzone"/> Częściowo zjedzone
                                                                    </Fragment>                                                                    
                                                                }                                                                
                                                                {
                                                                    item.podwieczorek == 2 &&
                                                                    <Fragment>
                                                                        <img src={e_bad} className="book_emo" title="Niezjedzone wcale"/> Niezjedzone wcale
                                                                    </Fragment>                                                                   
                                                                }
                                                            </div>
                                                }


                                                    <br/>

                                                {
                                                            item.praca_z_ksiazka != 0 &&
                                                            <div>
                                                                <div className="book_title">Praca z książką:</div>                                                                
                                                                {
                                                                    item.praca_z_ksiazka == 3 &&
                                                                    <Fragment>
                                                                            <img src={e_smile} className="book_emo" title="Bardzo dobrze"/> Bardzo dobrze
                                                                    </Fragment>                                                                   
                                                                }
                                                                {
                                                                    item.praca_z_ksiazka == 2 &&
                                                                    <Fragment>
                                                                                <img src={e_neutral} className="book_emo" title="Średnio"/> Średnio
                                                                    </Fragment>                                                                    
                                                                }                                                                
                                                                {
                                                                    item.praca_z_ksiazka == 1 &&
                                                                    <Fragment>
                                                                            <img src={e_bad} className="book_emo" title="Słabo"/> Słabo
                                                                    </Fragment>                                                                   
                                                                }

                                                            </div>
                                                }

                                                {
                                                            item.prace_plastyczne != 0 &&
                                                            <div>
                                                                <div className="book_title">Prace plastyczne:</div>
                                                                {
                                                                    item.prace_plastyczne == 3 &&
                                                                    <Fragment>
                                                                        <img src={e_smile} className="book_emo" title="Bardzo dobrze"/> Bardzo dobrze
                                                                    </Fragment>                                                                    
                                                                }
                                                                {
                                                                    item.prace_plastyczne == 2 &&
                                                                    <Fragment>
                                                                            <img src={e_neutral} className="book_emo" title="Średnio"/> Średnio
                                                                    </Fragment>                                                                    
                                                                }                                                                
                                                                {
                                                                    item.prace_plastyczne == 1 &&
                                                                    <Fragment>
                                                                            <img src={e_bad} className="book_emo" title="Słabo"/> Słabo
                                                                    </Fragment>                                                                    
                                                                }
                                                            </div>
                                                }

                                                
                                                {
                                                            item.praca_w_grupie != 0 &&
                                                            <div>
                                                                <div className="book_title">Praca w grupie:</div>
                                                                {
                                                                    item.praca_w_grupie == 3 &&
                                                                    <Fragment>
                                                                        <img src={e_smile} className="book_emo" title="Bardzo dobrze"/> Bardzo dobrze
                                                                    </Fragment>                                                                   
                                                                }
                                                                {
                                                                    item.praca_w_grupie == 2 &&
                                                                    <Fragment>
                                                                            <img src={e_neutral} className="book_emo" title="Średnio"/> Średnio
                                                                    </Fragment>                                                                    
                                                                }                                                                
                                                                {
                                                                    item.praca_w_grupie == 1 &&
                                                                    <Fragment>
                                                                            <img src={e_bad} className="book_emo" title="Słabo"/> Słabo
                                                                    </Fragment>                                                                    
                                                                }
                                                            </div>
                                                }
                                                <br/>
                                                {
                                                            item.nowa_litera.length != 0 &&  item.nowa_litera != '?'  &&
                                                            <div>
                                                                <div className="book_title">Poznana listera:</div>
                                                                {item.nowa_litera}
                                                            </div>
                                                }

                                                <br/>
                                                {
                                                            item.logopeda_uwagi.length > 0 &&
                                                            <div>
                                                                <div className="book_title">Uwagi logopedy:</div>
                                                                {item.logopeda_uwagi}
                                                            </div>
                                                }



                                    </div> 
                                    
                                </li>

                            </Fragment>

                        } )
                    }
            </ul>

    </div>
}


export default Book;